// Generated by Copilot
import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { PourFormatDeleteCard } from './components/PourFormatDeleteCard';
import { PourFormatDetailsCard } from './components/PourFormatDetailsCard';

// import { ProductsCard } from './components/ProductsCard';

export function PourFormatDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const pourFormatQueryResults = useQuery({
        queryKey: ['pourFormat', id],
        queryFn: () => Api.Servings.PourFormat.getPourFormat(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={pourFormatQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <PourFormatDetailsCard pourFormat={data} />
                            {/* <ProductsCard
                                pourFormat={data}
                                refetch={pourFormatQueryResults.refetch}
                            /> */}
                            <Can I="delete" a="PourFormat">
                                <PourFormatDeleteCard pourFormat={data} />
                            </Can>
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
